app.service('partnerSubscriptionGroup', function (
	productCardConfig,
	loading,
	modal,
	partnerSubscriptionsModal,
	productCardManager
) {

	class PartnerSubscriptionGroup {
		constructor($element) {
			this.setElements($element);

			this.isExpanded = this.$element.data('expanded');
			this.groupId = this.$element.data('groupId');
			this.isAnyOptionSelected = false;

			this.setEvents();
			this.showUserSelectedSubscription();
			this.render();
		}

		showUserSelectedSubscription() {
			this.expandIfAnyOptionSelected();
		}

		setElements($element) {
			this.$element = $element;
			this.$subscriptionOption = this.$element.find('.option-subscription');
			this.$emptyOption = this.$element.find('.option-empty');
			this.$changeOption = this.$element.find('.option-name-change');
			this.$subscriptionExpanded = this.$element.find('.subscription-expanded');
			this.$subscriptionCollapsed = this.$element.find('.subscription-collapsed');

			const $allOptionNames = this.$element.find('.option-name');
			this.$defaultOptionName = $allOptionNames.filter('.option-default');
			this.$selectedOptionNames = $allOptionNames.not(this.$defaultOptionName);
		}

		setEvents() {
			this.$element
				.on('click', '.js-preview-partner-subscription', e => this.handlePreviewPartnerSubscriptionClick(e))
				.on('click', '.js-empty-partner-subscription', e => this.handleEmptyPartnerSubscriptionClick(e));
		}

		handlePreviewPartnerSubscriptionClick(e) {
			const partnerSubscriptionGroupId = $(e.currentTarget).data('groupId');

			loading.start();
			this.fetchPartnerSubscription()
				.then(content => partnerSubscriptionsModal.show({
					content,
					partnerSubscriptionGroupId,
					onChange: data => this.handlePartnerSubscriptionChange(data)
				}))
				.fail(() => modal.alert('[Usługi abonamentowe] Błąd pobierania danych.'))
				.always(loading.stop);
			this.selectedSubscriptionAnalytic(this.$element.find('.available-options .is-visible').data('id'))
		}

		selectedSubscriptionAnalytic(optionId) {
			const subscriptionId = optionId || 'standardowy';
			if ($('.price-tab.price-instalment-tab[data-context="instalment"].is-active').length > 0) {
				UA.interaction('KP_Crossell', 'Abonament_' + subscriptionId + '_raty', 'Klikniecie')
			} else {
				UA.interaction('KP_Crossell', 'Abonament_' + subscriptionId, 'Klikniecie')
			}
		}

		fetchPartnerSubscription() {
			return $.ajax({
				url: '/partner-subscriptions.ltr',
				data: {
					productId: productCardConfig.getData().id,
					partnerSubscriptionGroupId: this.groupId
				}
			});
		}

		handleEmptyPartnerSubscriptionClick(e) {
			this.isAnyOptionSelected = false;
			const partnerSubscriptionGroupId = $(e.currentTarget).data('groupId');
			productCardManager.emptyPartnerSubscription(parseInt(partnerSubscriptionGroupId));
			this.render();
			if ($('.price-tab.price-instalment-tab[data-context="instalment"].is-active').length > 0) {
				UA.interaction('KP_Crossell', 'Abonament_BRAK_raty', 'Klikniecie');
			} else {
				UA.interaction('KP_Crossell', 'Abonament_BRAK', 'Klikniecie');
			}
		}

		expandIfAnyOptionSelected() {
			this.isAnyOptionSelected = productCardManager.hasAnyPartnerSubscription(this.groupId);
			if (!this.isExpanded && this.isAnyOptionSelected) {
				this.isExpanded = true;
			}
		}

		handlePartnerSubscriptionChange() {
			this.expandIfAnyOptionSelected();
			this.render();
		}

		render() {
			this.$subscriptionExpanded.toggleClass('is-visible', this.isExpanded);
			this.$subscriptionCollapsed.toggleClass('is-visible', !this.isExpanded);
			this.$subscriptionOption.toggleClass('is-active', this.isAnyOptionSelected);
			this.$emptyOption.toggleClass('is-active', !this.isAnyOptionSelected);
			this.$changeOption.toggleClass('is-visible', this.isAnyOptionSelected);
			this.$defaultOptionName.toggleClass('is-visible', !this.isAnyOptionSelected);
			this.renderSelectedOptionNames();
		}

		renderSelectedOptionNames() {
			const $visibleOptions = this.$selectedOptionNames.filter((i, option) => productCardManager.hasPartnerSubscription(parseInt(option.dataset.id)));
			$visibleOptions.addClass('is-visible');

			const $lastVisibleOption = $visibleOptions.last();
			$lastVisibleOption.addClass('is-last-visible');

			$lastVisibleOption.siblings().removeClass('is-last-visible');
			this.$selectedOptionNames.not($visibleOptions).removeClass('is-last-visible is-visible');
		}
	}

	function instanceOf($element) {
		return new PartnerSubscriptionGroup($element);
	}

	return {
		instanceOf
	};
});